import React, { useState } from 'react';
import PropTypes from "prop-types";
import Spacer from "noood/comp/ui/spacer/Spacer";
import CenteredColumnWidth from "noood/comp/ui/containers/CenteredColumnWidth";
export default function NoRecordsFound(props) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      marginTop: "10%"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-title text-negative"
  }, props.message), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 2
  }), /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 400,
    style: {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary",
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center"
    }
  }, props.caption)));
}
NoRecordsFound.propTypes = {
  message: PropTypes.string,
  caption: PropTypes.string
};
NoRecordsFound.defaultProps = {
  message: 'No records found.',
  caption: 'That\'s it. Zilch. Nada.'
};